var _effectorFileName = "/builds/gmini/front-common/src/Explorer/ctx/baseOperations.ts";
import "core-js/modules/es.number.constructor.js";
import { openRenameItemForm, openNewCategoryForm, openNewEntityForm, openCopyForm } from "../Model";
import { isAssembly, isEntity } from "../Node";
import { CreateCopyIcon, CreateEntityIcon, CreateFolderIcon, DeleteIcon, RenameIcon } from "./icons";
export function baseExplorerOperations(params) {
  var onRemoveItem = params.onRemoveItem,
      createEntityTitle = params.createEntityTitle,
      dataTestId = params.dataTestId,
      createFolderEventHandler = params.createFolderEventHandler,
      createEntityEventHandler = params.createEntityEventHandler;

  var isReadOnly = function isReadOnly(node) {
    return !!node && (isAssembly(node) || isEntity(node)) && node.readOnly;
  };

  return [{
    title: 'Создать папку',
    dataTestId: 'createFolder',
    customIcon: CreateFolderIcon,
    onClick: function onClick(_ref) {
      var node = _ref.node,
          onOpen = _ref.onOpen;

      if (onOpen) {
        onOpen();
      }

      openNewCategoryForm({
        parentCategoryId: (node === null || node === void 0 ? void 0 : node.id) || undefined
      });
      createFolderEventHandler === null || createFolderEventHandler === void 0 ? void 0 : createFolderEventHandler();
    },
    show: function show(_ref2) {
      var node = _ref2.node;
      return !node || node.type === 'Category';
    }
  }, {
    title: createEntityTitle,
    dataTestId: dataTestId,
    customIcon: CreateEntityIcon,
    onClick: function onClick(_ref3) {
      var node = _ref3.node,
          onOpen = _ref3.onOpen;

      if (onOpen) {
        onOpen();
      }

      openNewEntityForm({
        parentCategoryId: (node === null || node === void 0 ? void 0 : node.id) || undefined
      });
      createEntityEventHandler === null || createEntityEventHandler === void 0 ? void 0 : createEntityEventHandler();
    },
    show: function show(_ref4) {
      var node = _ref4.node;
      return !node || node.type === 'Category';
    }
  }, {
    title: 'Переименовать',
    dataTestId: 'renameEntity',
    customIcon: RenameIcon,
    onClick: function onClick(_ref5) {
      var node = _ref5.node;

      if (node) {
        openRenameItemForm(node);
      }
    },
    show: function show(_ref6) {
      var node = _ref6.node,
          emptyPanelClick = _ref6.emptyPanelClick;
      return !!node && !emptyPanelClick;
    },
    disabled: function disabled(_ref7) {
      var node = _ref7.node;
      return isReadOnly(node);
    },
    tooltipTitle: function tooltipTitle(_ref8) {
      var node = _ref8.node;
      return isReadOnly(node) ? 'У вас нет прав на редактирование' : '';
    }
  }, {
    title: 'Создать копию',
    dataTestId: 'createEntityCopy',
    customIcon: CreateCopyIcon,
    onClick: function onClick(_ref9) {
      var node = _ref9.node;

      if (node && (node === null || node === void 0 ? void 0 : node.type) !== 'Category') {
        var _node$parentNode;

        openCopyForm({
          id: node.id,
          version: node.version,
          type: node.type,
          parentCategoryId: (_node$parentNode = node.parentNode) === null || _node$parentNode === void 0 ? void 0 : _node$parentNode.id
        });
      }
    },
    show: function show(_ref10) {
      var node = _ref10.node;
      return !!node && node.type !== 'Category';
    },
    //TODO убрать когда Саша сделает копирование
    disabled: function disabled(_ref11) {
      var node = _ref11.node;
      return (node === null || node === void 0 ? void 0 : node.type) === 'Assembly';
    }
  }, {
    title: 'Удалить',
    dataTestId: 'deleteEntity',
    customIcon: DeleteIcon,
    onClick: function onClick(_ref12) {
      var node = _ref12.node;

      if (node) {
        onRemoveItem(node);
      }
    },
    show: function show(_ref13) {
      var emptyPanelClick = _ref13.emptyPanelClick;
      return !emptyPanelClick;
    },
    disabled: function disabled(_ref14) {
      var node = _ref14.node;
      return !!((node === null || node === void 0 ? void 0 : node.type) === 'Category' && node !== null && node !== void 0 && node.total) || isReadOnly(node);
    },
    tooltipTitle: function tooltipTitle(_ref15) {
      var node = _ref15.node;

      if (isReadOnly(node)) {
        return 'У вас нет прав на редактирование';
      }

      if ((node === null || node === void 0 ? void 0 : node.type) === 'Category' && Number(node === null || node === void 0 ? void 0 : node.total) > 0) {
        return 'Нельзя удалить непустую папку';
      }

      return '';
    }
  }];
}